var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderFailedOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85693 10.0753C4.85693 7.82011 6.6851 5.99194 8.94027 5.99194H22.9403C23.4596 5.99194 23.9522 6.22263 24.2847 6.62162L29.5933 12.9919H48.6069C50.8621 12.9919 52.6903 14.8201 52.6903 17.0753V27.5753C52.6903 28.5418 51.9068 29.3253 50.9403 29.3253C49.9738 29.3253 49.1903 28.5418 49.1903 27.5753V17.0753C49.1903 16.7531 48.9291 16.4919 48.6069 16.4919H28.7736C28.2542 16.4919 27.7617 16.2613 27.4292 15.8623L22.1206 9.49194H8.94027C8.6181 9.49194 8.35693 9.75311 8.35693 10.0753V47.4086C8.35693 47.7308 8.61808 47.9919 8.94027 47.9919H26.4403C27.4068 47.9919 28.1903 48.7754 28.1903 49.7419C28.1903 50.7084 27.4068 51.4919 26.4403 51.4919H8.94027C6.68512 51.4919 4.85693 49.6638 4.85693 47.4086V10.0753Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5362 34.5045C35.2196 33.8211 36.3276 33.8211 37.011 34.5045L48.6777 46.1712C49.3611 46.8546 49.3611 47.9626 48.6777 48.646C47.9943 49.3295 46.8862 49.3295 46.2028 48.646L34.5362 36.9794C33.8527 36.296 33.8527 35.1879 34.5362 34.5045Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6777 34.5045C49.3611 35.1879 49.3611 36.296 48.6777 36.9794L37.011 48.646C36.3276 49.3295 35.2196 49.3295 34.5362 48.646C33.8527 47.9626 33.8527 46.8546 34.5362 46.1712L46.2028 34.5045C46.8862 33.8211 47.9943 33.8211 48.6777 34.5045Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFailedOne);
export default __webpack_public_path__ + "static/media/folder-failed-one.89f6646a.svg";
export { ForwardRef as ReactComponent };